import { v4 } from '@lukeed/uuid';
export async function appendText(fileCollection, relativePath, text, options = {}) {
    const source = await getExtendedSourceFromText(relativePath, text, options);
    await fileCollection.appendExtendedSource(source);
}
async function getExtendedSourceFromText(relativePath, text, options = {}) {
    const url = new URL(relativePath, 'ium:/');
    const blob = new Blob([await text], { type: 'text/plain' });
    return {
        uuid: v4(),
        relativePath: url.pathname,
        name: relativePath.split('/').pop(),
        lastModified: options.dateModified || Date.now(),
        baseURL: 'ium:/',
        text: () => blob.text(),
        stream: () => blob.stream(),
        arrayBuffer: () => blob.arrayBuffer(),
    };
}
//# sourceMappingURL=appendText.js.map